import styled from '@emotion/styled';
import { colors } from 'inpock-ui-react/dist/src/color';

import IconCopy from '@/assets/icons/icon-copy.svg';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  padding: 20px 15px;
  background-color: ${colors.gray100};
`;

export const OrderInfoAccount = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: 8px;
`;

export const ButtonCopy = styled.div`
  width: 12px;
  height: 18px;
  background-image: url(${IconCopy});
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  cursor: pointer;
`;
